import React, { useState } from "react";
import classnames from "classnames";
import { useDataLoader } from "react-remote-data-hooks";
import { useSelector } from "react-redux";
import { Participant, State } from "../../../../core";
import {
  Controller,
  useForm,
} from "../../../../../node_modules/react-hook-form/dist";
import RemoteDataMultiSelectDropDown from "../../../../components/dropdown/RemoteDataMultiSelectDropDown";
import api from "../../../../api";
import { UserImage } from "../../../../components/user-image";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";

export interface FormProps {
  sendToUserIds?: Participant[];
  subject?: string;
  content?: string;
}

const SendClientApprovalForm: React.FunctionComponent<{
  onClose?: () => void;
  onSuccess?: () => void;
  approvalType?: string;
  proposalId?: string;
  documentSettingsId?: string;
  documentId?: string;
  title?: string;
  documentCopyType?: string;
  compId?: string;
  proposedPropertyId?: string;
  isReloadUser?: boolean
  onAddUser?: (compId: string) => void;
}> = (props) => {
  const profile = useSelector((state: State) => state.authUser.profile);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { control, handleSubmit, errors, watch } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
    shouldFocusError: true,
  });

  // const loadShowroom = async () => {
  //   const response = await api.proposal.getParticipants(props.proposalId);
  //   return response;
  // };

  const loadPeople = async () => {
    const response = await api.proposal.getParticipants(props.proposalId);
    if (!props?.compId) {
      return response;
    } else if (props?.compId) {
      return [...response, { firstLastName: 'AddNewUser' }];
    }
    return response;
  };

  const loadLandLords = async () => {
    const type = 'doc'
    const response = await api.sitevisit.getLandLords(
      props?.proposedPropertyId!, type
    );
    // return response;
    const formattedResponse = [...response, { contactName: 'AddLandLord' }]
    return formattedResponse;
  };

  const onSubmit = async (data: FormProps) => {
    setIsSubmitting(true);
    const createProposalData = {
      approvalType: props.approvalType,
      documentSettingsId: props?.documentSettingsId,
      sendToUserIds: data.sendToUserIds?.map((item: any) => item.customerId),
      subject: data.subject,
      content: data.content,
      documentCopyType: props.documentCopyType,
    };

    await api.proposalDocument.requestApproval(
      createProposalData,
      props.documentId!
    );
    setIsSubmitting(false);
    const message =
      props.approvalType === "Client"
        ? "Sent For Client Approval"
        : "Sent For Vendor / Owner Approval";
    toastr.success("Success", `${props.title} successfully ${message}`);
    props.onSuccess?.();
  };

  return (
    <>
      <div
        className="legal-due-diligence detail-poupup detail-poupup--sm detail-poupup--mdx detail-poupup--over bg-gray-100 position-fixed top-0 w-100 h-100 overflow-auto in bg-white"
        style={{ zIndex: 1053 }}
      >
        <div className="container-fluid bg-gray-100 border-bottom py-3">
          <div className="row align-items-center">
            <div className="col-auto">
              <i
                className="icon-close font-xl cursor-pointer"
                onClick={() => {
                  props.onClose?.();
                }}
              ></i>
            </div>
            <div className="co">
              <h2 className="mb-sm-0 font-base">
                {props.approvalType === "Client"
                  ? "Send For Client Approval"
                  : "Send For Vendor / Owner Approval"}
              </h2>
            </div>
          </div>
        </div>
        <div className="container-fluid bg-white client-approval-form px-1">
          <div className="px-4 py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              {props?.approvalType === 'Client' ?
                <div className="form-group font-weight-semibold mb-3">
                  <label htmlFor="" className="font-xs">
                    Select User<span className="text-danger">*</span>
                  </label>
                  <Controller
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => {
                        return value?.length > 0;
                      },
                    }}
                    name="sendToUserIds"
                    render={({ onChange, value, name }) => (
                      <RemoteDataMultiSelectDropDown
                        loadData={loadPeople}
                        textField="firstLastName"
                        value={value}
                        defaultValue={value}
                        isReload={props.isReloadUser}
                        valueField="_id"
                        onChange={(val) => {
                          // onChange(val);                      
                          onChange(val.filter((item: { firstLastName: string; }) => item?.firstLastName !== "AddNewUser").map((item: {_id:string})=>item._id));

                        }}
                        itemComponent={({ item }) => (
                          <React.Fragment>
                            {(item?.firstLastName === "AddNewUser" && props?.compId) ?
                              <>
                                <button
                                  type="button"
                                  className="btn btn-link font-md p-0 font-weight-semibold"
                                  onClick={() => props?.onAddUser?.(props?.compId || '')}
                                >
                                  + Add New User
                                </button>
                              </>
                              :
                              <UserImage
                                user={item}
                              ></UserImage>
                            }
                          </React.Fragment>
                        )}
                        tagComponent={({ item }) => (
                          <UserImage
                            user={item}
                          ></UserImage>
                        )}
                        placeholder="Select User"
                      ></RemoteDataMultiSelectDropDown>
                    )}
                  />
                  {errors.sendToUserIds && (
                    <ErrorMessage> Users is required</ErrorMessage>
                  )}
                </div> :

                <div className="form-group font-weight-semibold mb-3">
                  <label htmlFor="" className="font-xs">
                    Select User"<span className="text-danger">*</span>
                  </label>
                  <Controller
                    control={control}
                    rules={{
                      required: true,
                      validate: (value) => {
                        return value?.length > 0;
                      },
                    }}
                    name="sendToUserIds"
                    render={({ onChange, value, name }) => (

                      <RemoteDataMultiSelectDropDown
                        loadData={loadLandLords}
                        isReload={props?.isReloadUser}
                        textField="contactName"
                        value={value}
                        defaultValue={value}
                        valueField="_id"
                        onChange={(val) => {
                          onChange(val.filter((item: { contactName: string; }) => item?.contactName !== "AddLandLord"));
                        }}
                        placeholder="Select User"
                        itemComponent={({ item }) => (
                          <React.Fragment>
                            {item.contactName === 'AddLandLord' ?
                              <>
                                <button
                                  type="button"
                                  className="btn btn-link font-md p-0 font-weight-semibold"
                                  onClick={() => props?.onAddUser?.(props?.compId || '')}
                                >
                                  + Add New User
                                </button>
                              </>
                              :
                              <UserImage
                                user={{ name: item?.contactName }}
                              ></UserImage>
                            }
                          </React.Fragment>
                        )}
                        tagComponent={({ item }) => (
                          <UserImage
                            user={{ name: item?.contactName }}
                          ></UserImage>
                        )}
                      />
                    )}
                  />
                  {errors.sendToUserIds && (
                    <ErrorMessage> Users is required</ErrorMessage>
                  )}
                </div>

              }

              <div className="form-group font-weight-semibold mb-3">
                <label htmlFor="" className="font-xs">
                  Subject<span className="text-danger">*</span>
                </label>

                <Controller
                  control={control}
                  rules={{
                    required: true,
                  }}
                  name="subject"
                  render={({ onChange, value, name }) => (
                    <input
                      type="text"
                      className="form-control rounded-sm font-weight-semibold"
                      placeholder="Subject"
                      name={name}
                      value={value}
                      onChange={onChange}
                      id="subject"
                    />
                  )}
                />
                {errors.subject && (
                  <ErrorMessage> Subject is required</ErrorMessage>
                )}
              </div>
              <div className="form-group font-weight-semibold mb-3">
                <label htmlFor="" className="font-xs">
                  Content
                </label>
                <Controller
                  control={control}
                  name="content"
                  render={({ onChange, value, name }) => (
                    <textarea
                      className="form-control rounded-sm font-weight-semibold"
                      placeholder="Enter Content"
                      name={name}
                      value={value}
                      onChange={onChange}
                      id="content"
                    />
                  )}
                />
              </div>
              <div className="form-group font-weight-semibold mb-3 text-right pt-3">
                <button
                  type="button"
                  className="btn btn-outline-dark font-weight-semibold font-normal mr-2"
                  onClick={props.onClose}
                >
                  <span className="px-3">Cancel</span>
                </button>
                <button
                  disabled={isSubmitting}
                  className="btn btn-primary font-weight-semibold font-normal"
                >
                  <span className="px-3">Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop modal-backdrop--over fade show"
        style={{ zIndex: 1052 }}
      ></div>
    </>
  );
};

export default SendClientApprovalForm;
